<template>
  <div class="content-wrap personal-certificate">
    <div class="page-header">
      <div class="page-header-main">
        <h2>团体会员证书</h2>
        <p>浙江省风景园林学会团体会员电子证书</p>
      </div>
      <div class="page-header-badge" v-if="hasCertificate">已颁发</div>
    </div>

    <div class="certificate-panel" v-if="hasCertificate">
      <div class="certificate-frame">
        <div class="certificate-frame-inner">
          <div class="certificate-paper">
            <img :src="certificateUrl" alt="团体会员证书" @click="previewCertificate" />
          </div>
        </div>
      </div>

      <div class="certificate-meta">
        <div class="meta-card">
          <div class="meta-title">证书信息</div>
          <div class="meta-row">
            <span class="label">单位名称</span>
            <span class="value">{{ memOrg.orgName || '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="label">会员编号</span>
            <span class="value">{{ memOrg.memCode || '-' }}</span>
          </div>
          <div class="meta-row">
            <span class="label">会员类型</span>
            <span class="value">{{ orgTypeText }}</span>
          </div>
          <div class="meta-row">
            <span class="label">有效期</span>
            <span class="value">{{ validPeriodText }}</span>
          </div>
          <div class="meta-row">
            <span class="label">通讯地址</span>
            <span class="value">{{ memOrg.orgAddress || '-' }}</span>
          </div>
        </div>

        <div class="action-card">
          <div class="action-title">证书操作</div>
          <p class="action-desc">证书在会费缴纳审核通过后自动生成，请妥善保存。</p>
          <button class="btn-primary" type="button" @click="previewCertificate">查看大图</button>
          <a class="btn-outline" :href="certificateUrl" target="_blank" rel="noopener noreferrer">下载证书</a>
        </div>
      </div>
    </div>

    <div class="empty-panel" v-else>
      <div class="empty-icon"></div>
      <div class="empty-title">暂无团体会员证书</div>
      <div class="empty-desc">
        完成会费缴纳并经学会审核确认后，系统将自动为您生成团体会员证书。
      </div>
      <button
        v-if="showPayEntry"
        class="btn-primary empty-pay-btn"
        type="button"
        @click="goPay"
      >
        前往缴纳会费
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import router from '@/router';

const ORG_TYPE_MAP = {
  '1501': '理事单位会员',
  '1502': '常务理事单位会员',
  '1503': '单位会员',
};

export default {
  computed: {
    ...mapState(['user']),
    memOrg() {
      return (this.user && this.user.memOrgVo) || {};
    },
    certificateUrl() {
      return this.memOrg.certificateUrl || '';
    },
    hasCertificate() {
      return !!this.certificateUrl;
    },
    orgTypeText() {
      return this.memOrg.orgTypeDicValue
        || ORG_TYPE_MAP[this.memOrg.orgTypeDicKey]
        || '-';
    },
    validPeriodText() {
      const start = this.user && this.user.membershipFeeStartDate;
      const end = this.user && this.user.membershipFeeValidDate;
      if (!start || !end) {
        return end ? moment(end * 1000).format('YYYY年M月D日') : '-';
      }
      return `${moment(start * 1000).format('YYYY年M月D日')} 至 ${moment(end * 1000).format('YYYY年M月D日')}`;
    },
    showPayEntry() {
      return this.user
        && this.user.memType === 'org'
        && !this.user.isCheckMemFee
        && this.user.isMemValid != '1';
    },
  },
  methods: {
    previewCertificate() {
      if (!this.certificateUrl) {
        return;
      }
      window.open(this.certificateUrl, '_blank');
    },
    goPay() {
      router.push('/system/user');
    },
  },
};
</script>

<style lang="less" scoped>
.personal-certificate {
  background: #ffffff;
  min-height: 640px;
  padding: 28px 32px 40px;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eef0f2;

  h2 {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 600;
    color: #131415;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #8c8c8c;
  }

  &-badge {
    padding: 6px 14px;
    border-radius: 16px;
    background: rgba(6, 174, 99, 0.1);
    color: #06ae63;
    font-size: 13px;
    font-weight: 500;
  }
}

.certificate-panel {
  display: flex;
  gap: 28px;
  align-items: flex-start;
}

.certificate-frame {
  flex: 1.2;
  min-width: 0;
  padding: 24px;
  background: linear-gradient(180deg, #faf8f3 0%, #f3efe6 100%);
  border: 1px solid #e8e2d6;
  border-radius: 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.certificate-frame-inner {
  padding: 18px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.certificate-paper {
  overflow: hidden;
  border-radius: 4px;
  background: #fffdf8;

  img {
    display: block;
    width: 100%;
    height: auto;
    cursor: zoom-in;
  }
}

.certificate-meta {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.meta-card,
.action-card {
  padding: 18px 20px;
  border: 1px solid #eef0f2;
  border-radius: 10px;
  background: #fafbfc;
}

.meta-title,
.action-title {
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #131415;
}

.meta-row {
  display: flex;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    flex: 0 0 72px;
    color: #8c8c8c;
  }

  .value {
    flex: 1;
    color: #333;
    word-break: break-all;
  }
}

.action-desc {
  margin: 0 0 16px;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.6;
}

.btn-primary,
.btn-outline {
  display: block;
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
}

.btn-primary {
  border: none;
  background: #06ae63;
  color: #fff;
}

.btn-outline {
  border: 1px solid #06ae63;
  background: #fff;
  color: #06ae63;
}

.empty-panel {
  padding: 80px 20px;
  text-align: center;
  background: #fafbfc;
  border: 1px dashed #dde1e6;
  border-radius: 12px;
}

.empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: rgba(6, 174, 99, 0.1) url(../../assets/images/icon-notice.svg) no-repeat center center;
  background-size: 28px 28px;
}

.empty-title {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.empty-desc {
  max-width: 420px;
  margin: 0 auto;
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.7;
}

.empty-pay-btn {
  width: 180px;
  margin: 24px auto 0;
}
</style>
